var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrobeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 14.5,
    fill: "white",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_176_1060",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_176_1060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 25C22.8333 25 23.5417 24.7083 24.125 24.125C24.7083 23.5417 25 22.8333 25 22C25 21.1667 24.7083 20.4583 24.125 19.875C23.5417 19.2917 22.8333 19 22 19C21.1667 19 20.4583 19.2917 19.875 19.875C19.2917 20.4583 19 21.1667 19 22C19 22.8333 19.2917 23.5417 19.875 24.125C20.4583 24.7083 21.1667 25 22 25ZM22 27C20.6167 27 19.4375 26.5125 18.4625 25.5375C17.4875 24.5625 17 23.3833 17 22C17 20.6167 17.4875 19.4375 18.4625 18.4625C19.4375 17.4875 20.6167 17 22 17C23.3833 17 24.5625 17.4875 25.5375 18.4625C26.5125 19.4375 27 20.6167 27 22C27 23.3833 26.5125 24.5625 25.5375 25.5375C24.5625 26.5125 23.3833 27 22 27ZM15 23H11V21H15V23ZM33 23H29V21H33V23ZM21 15V11H23V15H21ZM21 33V29H23V33H21ZM16.4 17.75L13.875 15.325L15.3 13.85L17.7 16.35L16.4 17.75ZM28.7 30.15L26.275 27.625L27.6 26.25L30.125 28.675L28.7 30.15ZM26.25 16.4L28.675 13.875L30.15 15.3L27.65 17.7L26.25 16.4ZM13.85 28.7L16.375 26.275L17.75 27.6L15.325 30.125L13.85 28.7Z",
    fill: "#AD5F04"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrobeButton);
export default __webpack_public_path__ + "static/media/strobeButton.772eb94467610230fe71e18f972fc487.svg";
export { ForwardRef as ReactComponent };